import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LargeFont from "../LargeFont";
import styles from "./styles.module.scss";
const UserIcon = ({ name }) => {
    const nameArray = name.split(" ");
    const firstLetter = nameArray.length > 0 ? nameArray[0].charAt(0) : "";
    const secondLetter = nameArray.length > 0 && nameArray.length <= 2 ? nameArray[1]?.charAt(0) : "";
    return (_jsx("div", { className: styles.icon, children: _jsx(LargeFont, { fontWeight: 400, children: _jsxs("span", { className: styles.initials, children: [firstLetter, secondLetter] }) }) }));
};
export default UserIcon;
